import type { Variants } from 'motion'

export const listVariants:Variants = {
  initial: {
    opacity: 0,
    transition: {
      when: 'afterChildren',
    },
  },
  animate: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: .15,
    },
  },
}

export const listItemVariants: Variants = {
  initial: {
    opacity: 0,
    y: '8px'
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .4,
      type: 'tween',
      ease: 'easeInOut'
    }
  }
}

export const fadeFromLeftVariants: Variants = {
  initial: {
    opacity: 0,
    x: '-16px'
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: .5,
      ease: 'easeInOut'
    }
  }
}

export const fadeFromBottomVariants: Variants = {
  initial: {
    opacity: 0,
    y: '8px'
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .4,
      type: 'tween',
      ease: 'easeInOut'
    }
  }
}

